<style>
.v-snack__content {
  padding: 14px 10px;
}
</style>

<template>

  <v-snackbar v-model="snackbar" v-if="notification" :bottom="true" :timeout="timeout" :color="color" :auto-height="true">
    <strong>{{devices[notification.slug].name}}</strong> -
    {{content.type[notification.type]}}
    <v-btn flat @click="snackbar = false">
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>

</template>

<script>

import { mapGetters } from 'vuex'
export default {
    name: "snackbar",
    props: ['devices'],
    data() {
      return {
        locale: Lang.get(),
        snackbar: false,
        timeout: 6000,
        color: 'info',
        text: 'Hello, I\'m a snackbar'
      };
    },
    created() {
      this.setLang();
    },
    computed: mapGetters({
      notification: 'notifications/new',
    }),
    watch: {
      notification() {
        if (this.notification) {
          this.color = this.attachColor(this.notification.type)
          this.snackbar = true
        }
      }
    },
    methods: {
      attachColor(type){
        const NEGATIVE = ['NotConnected', 'NoSensor', 'FloodSuspected', 'LowBattery'];
        if (NEGATIVE.includes(type)) {
          return 'error';
        } else if (['MetTreshold','DoorOpened'].includes(type)) {
          return 'warning';
        } else {
          return 'info';
        }
      },
      setLang() {
          if (this.locale == "en") {
              this.content = {
                scrolldown: 'scroll down',
                type: {
                  NotConnected: 'Lost power or internet connection',
                  IsConnected: 'The power or internet connection is back',
                  NoSensor: 'The sensor has disconnected',
                  MetTreshold: 'Reached the threshold you set',
                  FixedMetTreshold: 'The indicators returned to normal',
                  FloodSuspected: 'The buoy identifies flooding',
                  FloodFixed: 'The buoy is back to normal',
                  DoorOpened: 'The sensor detected a door opening',
                  DoorClosed: 'The sensor detected a door closing',
                  LowBattery: 'The device has low battery',
                },
              };
          } else if (this.locale == "he") {
              this.content = {
                scrolldown: 'גלול למטה',
                type: {
                  NotConnected: 'איבד חיבור לחשמל או לאינטרנט',
                  IsConnected: 'חזר החיבור לחשמל או לאינטרנט',
                  NoSensor: 'החיישן לא מחובר',
                  MetTreshold: 'הגיע לסף שהגדרת',
                  FixedMetTreshold: 'המדדים חזרו למצב תקין',
                  FloodSuspected: 'המצוף מזהה הצפה',
                  FloodFixed: 'המצוף חזר למצב תקין',
                  DoorOpened: 'החיישן מזהה פתיחה של דלת',
                  DoorClosed: 'החיישן מזהה סגירה של דלת',
                  LowBattery: 'למכשיר יש סוללה חלשה',
                },
              };
          }
      }

    }
};

</script>
